import { render, staticRenderFns } from "./TaskNewDataTable.vue?vue&type=template&id=a50f5bd6&scoped=true"
import script from "./TaskNewDataTable.vue?vue&type=script&lang=js"
export * from "./TaskNewDataTable.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDataTable.vue?vue&type=style&index=0&id=a50f5bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f5bd6",
  null
  
)

export default component.exports